/**
 * Bundle Quantity Dropdown + Color Picker
 * When a pack tier is selected (qty > 1):
 *   - Shows "Tap the colours above to fill your pack" section
 *   - Intercepts clicks on the page's existing color swatches/links
 *   - Instead of navigating, adds that colour to the bundle picks
 *   - On Add to Cart, fetches each product's variant ID and adds individually
 */
(function() {
  'use strict';

  var wrap = document.getElementById('BundleQtySelect');
  if (!wrap) return;

  var trigger = wrap.querySelector('.BundleQty__Trigger');
  var valueSpan = wrap.querySelector('.BundleQty__Value');
  var optionsList = wrap.querySelector('.BundleQty__Options');
  var options = wrap.querySelectorAll('.BundleQty__Option');
  var hiddenInput = wrap.querySelector('input[name="quantity"]');

  var colorSection = document.getElementById('BundleColors');
  var countEl = colorSection ? colorSection.querySelector('[data-bundle-color-count]') : null;
  var picksEl = colorSection ? colorSection.querySelector('[data-bundle-picks]') : null;

  var currentQty = 1;
  var currentDiscountCode = '';
  var bundleActive = false;
  var selectedColors = []; // { color, handle, variantId, style }
  var variantCache = {}; // handle -> variantId

  if (!trigger || !optionsList || !hiddenInput) return;

  // Expose bundle state globally so color-ajax-nav can check
  window.__bundleMode = { active: false };

  // === DROPDOWN ===
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    optionsList.classList.toggle('open');
    trigger.setAttribute('aria-expanded', optionsList.classList.contains('open'));
  });

  function closeDropdown() {
    optionsList.classList.remove('open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  options.forEach(function(opt) {
    opt.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      options.forEach(function(o) {
        o.classList.remove('BundleQty__Option--selected');
        o.setAttribute('aria-selected', 'false');
      });
      opt.classList.add('BundleQty__Option--selected');
      opt.setAttribute('aria-selected', 'true');

      var qty = parseInt(opt.getAttribute('data-qty'));
      currentQty = qty;
      currentDiscountCode = opt.getAttribute('data-discount-code') || '';
      hiddenInput.value = qty;
      valueSpan.textContent = opt.querySelector('.BundleQty__OptLabel').textContent;

      var badge = opt.querySelector('.BundleQty__Badge');
      var existingBadge = trigger.querySelector('.BundleQty__Badge');
      if (existingBadge) existingBadge.remove();
      if (badge) {
        trigger.insertBefore(badge.cloneNode(true), trigger.querySelector('.BundleQty__Arrow'));
      }

      closeDropdown();

      // Activate/deactivate bundle mode
      if (qty > 1 && colorSection) {
        bundleActive = true;
        window.__bundleMode.active = true;
        colorSection.style.display = '';
        if (selectedColors.length > qty) {
          selectedColors = selectedColors.slice(0, qty);
        }
        renderPicks();
        updateCount();
      } else {
        bundleActive = false;
        window.__bundleMode.active = false;
        if (colorSection) colorSection.style.display = 'none';
        selectedColors = [];
        renderPicks();
      }
    });
  });

  document.addEventListener('click', function(e) { if (!wrap.contains(e.target)) closeDropdown(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDropdown(); });

  // === INTERCEPT COLOR SWATCH/LINK CLICKS ===
  // Capture phase so we fire BEFORE color-ajax-nav.js
  document.addEventListener('click', function(e) {
    if (!bundleActive) return;

    // Find color link (Combined Listings links)
    var link = e.target.closest('a[href*="/products/"]');

    if (link) {
      // Must be inside product section, not pair-with etc.
      var productSection = document.querySelector('[data-section-type="product"]');
      if (!productSection || !productSection.contains(link)) return;
      if (link.closest('.PairWith, .PairPane, .BundleColors, .BundleQty')) return;

      // If pack is already full, let the click through so they can browse other colors
      if (selectedColors.length >= currentQty) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var href = link.getAttribute('href');
      var handle = href.split('/products/')[1];
      if (!handle) return;
      handle = handle.split('?')[0].split('#')[0];

      // Get color name from tooltip, title, or derive from handle
      var color = link.getAttribute('data-tooltip') ||
                  link.getAttribute('title') ||
                  '';

      if (!color) {
        // Try to get from inner swatch label or text
        var innerLabel = link.querySelector('[data-tooltip]');
        if (innerLabel) color = innerLabel.getAttribute('data-tooltip');
      }

      if (!color) {
        // Derive from handle: "om-sarong-fuchsia" -> "Fuchsia"
        var parts = handle.split('-');
        color = parts[parts.length - 1];
        color = color.charAt(0).toUpperCase() + color.slice(1);
      }

      // Get swatch style
      var swatchEl = link.querySelector('[style*="background"]') || link;
      var style = swatchEl.getAttribute('style') || '';

      addColorPick(color, handle, null, style);
      return;
    }

    // Also handle native ColorSwatch labels (for products with color as a variant)
    var swatchLabel = e.target.closest('.ColorSwatch');
    if (swatchLabel) {
      var productSection2 = document.querySelector('[data-section-type="product"]');
      if (!productSection2 || !productSection2.contains(swatchLabel)) return;

      // If pack is full, let through
      if (selectedColors.length >= currentQty) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var tooltip = swatchLabel.getAttribute('data-tooltip') || swatchLabel.textContent.trim();
      var sStyle = swatchLabel.getAttribute('style') || '';

      addColorPick(tooltip, null, null, sStyle);
    }
  }, true); // CAPTURE PHASE

  function addColorPick(color, handle, variantId, style) {
    if (selectedColors.length >= currentQty) {
      // Pack is full — don't block, return 'full' so caller can let the click through
      return 'full';
    }

    if (!handle && !variantId && colorSection) {
      variantId = colorSection.getAttribute('data-current-variant-id');
    }

    selectedColors.push({
      color: color,
      handle: handle,
      variantId: variantId,
      style: style
    });

    renderPicks();
    updateCount();
  }

  function removePick(idx) {
    selectedColors.splice(idx, 1);
    renderPicks();
    updateCount();
  }

  function renderPicks() {
    if (!picksEl) return;
    if (!bundleActive) {
      picksEl.innerHTML = '';
      return;
    }
    if (selectedColors.length === 0) {
      picksEl.innerHTML = '<span class="BundleColors__Hint">Tap the colour swatches above to add to your pack</span>';
      return;
    }

    var html = '';
    selectedColors.forEach(function(sel, i) {
      html += '<button type="button" class="BundleColors__Pick" data-remove-idx="' + i + '" title="Click to remove">';
      html += '<span class="BundleColors__PickNum">' + (i + 1) + '</span>';
      html += '<span class="BundleColors__PickDot" style="' + escapeAttr(sel.style) + '"></span>';
      html += '<span class="BundleColors__PickName">' + escapeHtml(sel.color) + '</span>';
      html += '<span class="BundleColors__PickX">&times;</span>';
      html += '</button>';
    });
    picksEl.innerHTML = html;

    picksEl.querySelectorAll('[data-remove-idx]').forEach(function(btn) {
      btn.addEventListener('click', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        removePick(parseInt(btn.getAttribute('data-remove-idx')));
      });
    });
  }

  function updateCount() {
    if (!countEl) return;
    countEl.textContent = selectedColors.length + ' / ' + currentQty + ' selected';
    countEl.style.color = selectedColors.length === currentQty ? '#15803d' : '#888';
  }

  // === ADD TO CART OVERRIDE ===
  var form = wrap.closest('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function(e) {
      if (!bundleActive || selectedColors.length === 0) return;

      e.preventDefault();
      e.stopPropagation();

      if (selectedColors.length < currentQty) {
        if (countEl) {
          countEl.style.color = '#dc2626';
          countEl.textContent = 'Select ' + (currentQty - selectedColors.length) + ' more colour' + (currentQty - selectedColors.length > 1 ? 's' : '');
          setTimeout(function() { updateCount(); }, 2500);
        }
        return;
      }

      var addBtn = form.querySelector('[data-action="add-to-cart"], .ProductForm__AddToCart');
      if (addBtn) {
        addBtn.disabled = true;
        var s = addBtn.querySelector('span');
        if (s) s.textContent = 'Adding...';
      }

      resolveVariantIds().then(function() {
        var items = selectedColors
          .map(function(sel) { return { id: parseInt(sel.variantId, 10), quantity: 1 }; })
          .filter(function(it) { return it.id && !isNaN(it.id); });

        if (!items.length) throw new Error('No valid variants');

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Failed');
        return r.json();
      })
      .then(function() {
        // If a discount code is configured, apply it BEFORE re-rendering the cart
        // so the drawer shows the discounted total on first open. Automatic
        // (quantity-based) discounts need no code and apply on add by themselves.
        if (currentDiscountCode) {
          return fetch('/discount/' + encodeURIComponent(currentDiscountCode), { credentials: 'same-origin' }).catch(function() {});
        }
      })
      .then(function() {
        if (addBtn) {
          var s = addBtn.querySelector('span');
          if (s) s.textContent = 'Added to cart!';
          setTimeout(function() {
            addBtn.disabled = false;
            if (s) s.textContent = 'Add to cart';
          }, 2000);
        }
        // The theme's CartSection listens for 'product:added' to re-render the
        // mini-cart (re-running Liquid, so discounts/savings show) and open the
        // drawer — no manual drawer-open needed.
        document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: currentQty } }));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function() {
        if (addBtn) {
          var s = addBtn.querySelector('span');
          if (s) s.textContent = 'Error — try again';
          addBtn.disabled = false;
          setTimeout(function() { if (s) s.textContent = 'Add to cart'; }, 2000);
        }
      });
    });
  }

  function resolveVariantIds() {
    var handlePromises = {}; // handle -> Promise<variantId> (one fetch per unique colour)

    function getId(handle) {
      if (variantCache[handle]) return Promise.resolve(variantCache[handle]);
      if (!handlePromises[handle]) {
        handlePromises[handle] = fetch('/products/' + encodeURIComponent(handle) + '.json')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var v = data.product.variants.find(function(v2) { return v2.available; }) || data.product.variants[0];
            variantCache[handle] = String(v.id);
            return variantCache[handle];
          });
      }
      return handlePromises[handle];
    }

    var all = selectedColors.map(function(sel) {
      if (sel.variantId) return Promise.resolve();
      if (sel.handle) {
        return getId(sel.handle).then(function(id) { sel.variantId = id; });
      }
      sel.variantId = colorSection ? colorSection.getAttribute('data-current-variant-id') : null;
      return Promise.resolve();
    });

    return Promise.all(all);
  }

  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function escapeAttr(s) { return (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
})();
